import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  onAddingAnnotation,
  onAnnotationClickClosed,
  onAnnotationClickOpened,
  onAnnotationFocused,
  onAnnotationHoverClosed,
  onAnnotationHoverOpened,
  onAnnotationMarkerSelectedActiveClick,
  onAnnotationMarkerSelectedActiveHover,
  onAnnotationMarkerSelectedInActiveClick,
  onAnnotationMarkerSelectedInActiveHover,
  onCancelAddingAnnotation,
  onEditingAnnotation,
  onFirstRowMarkersReady,
  onOpenAnnotation,
  onVideoPaused,
  onVideoPlay,
  wsAnnotationChange,
  onAnnotationClickClosedV2,
  onAnnotationClickOpenedV2,
  onAnnotationsStateChanged,
} from '../../../../services/annotation.service';
import { NotificationService } from '../../../../services/notification.service';
import $ from 'jquery';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GeneralUtilsService } from '../../../../services/general-utils.service';
import { ExistingAnnotationData } from '@mtm/conversation-client-sdk-annotation';

@Component({
  selector: 'mtm-videojs-annotation-bar-list',
  templateUrl: './videojs-annotation-bar-list.component.html',
  styleUrl: './videojs-annotation-bar-list.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VideojsAnnotationBarListComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ViewChild('annotationCommentModal') annotationCommentModal: ElementRef;
  @ViewChild('annotationConcat') annotationConcat: ElementRef;
  @Input() player: any;
  @Input() projectId: any;
  @Input() sectionId: any;
  @Input() subsectionId: any;
  @Input() typeId: any;
  @Input() projectParticipants: any[];
  @Input() item: any;
  @Input() annotationPlugin: any;
  @Input() isPlayerReady: boolean = false;
  @Input() isAudio: boolean = false;
  @Input() isVideo: boolean = false;
  @Input() isPlaying: boolean = false;
  @Input() instanceId: string;
  @Input() disablePreview: boolean = false;
  @Input() progressBarClickedTime: number | null = null;

  isShowMoreAnnotations: boolean = false;
  duration: number = 0;
  activeAnnotation: any;
  modalPosition: any;
  concatPosition: any;
  annotationActiveToggled: boolean = false;
  annotationIn2DMatrixDataModel: any[];
  timelineItems: Array<
    { type: 'single'; startTime: number; annotation: any } | { type: 'group'; startTime: number; annotations: any[] }
  > = [];
  dropUpOpenStartTime: number | null = null;
  private dropUpJustOpened = false;
  private modalPositionRafId: number | null = null;
  private _cachedDuration: number | null = null;
  isVideoPaused: boolean = true;
  ngUnsubscribe = new Subject();

  get isAdding() {
    return this.annotationPlugin?.controls?.uiState?.adding && this.annotationPlugin?.controls?.uiState?.drawingEnabled;
  }

  get activeAnnotationPlugin() {
    return this.annotationPlugin?.annotationState?.activeAnnotation?.data;
  }

  get annotatingMode() {
    return this.isAdding || false;
  }

  get editingMode() {
    return this.annotationPlugin?.controls?.uiState?.editing || false;
  }

  get isAnnotationActive() {
    return this.annotatingMode || this.editingMode;
  }
  get annotations() {
    const raw: any[] = this.annotationPlugin?.annotationState?.annotationMessages || [];
    return raw.map((a: any) => {
      if (a?.range != null && a.range.start == null) {
        return { ...a, range: { ...a.range, start: 0 } };
      }
      return a;
    });
  }

  constructor(
    private readonly notificationService: NotificationService,
    private readonly generalUtilsService: GeneralUtilsService,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    onAnnotationHoverOpened.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onAnnotationHoverOpened(args),
    });
    onAnnotationHoverClosed.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onAnnotationHoverClosed(args),
    });
    onAnnotationClickOpened.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onAnnotationClickOpened(args),
    });
    onAnnotationClickClosed.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onAnnotationClickClosed(args),
    });
    onAddingAnnotation.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onAddingAnnotationHandler(args),
    });
    onCancelAddingAnnotation.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onCancelAddingAnnotationHandler(args),
    });
    onEditingAnnotation.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onEditingAnnotationHandeler(args),
    });
    onVideoPaused.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onVideoPausedHandler(args),
    });
    onVideoPlay.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => this.onVideoPlayHandler(args),
    });
    onAnnotationClickOpenedV2.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => {
        if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
          return;
        }
        this.annotationActiveToggled = true;
        this.activeAnnotation = args.annotation;
        this.scheduleModalPositionUpdate();
      },
    });
    onAnnotationClickClosedV2.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (args: any) => {
        if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
          return;
        }
        this.annotationActiveToggled = false;
        this.activeAnnotation = void 0;
      },
    });

    wsAnnotationChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.mapAnnotation2DMatrix();
    });
  }

  ngOnInit() {
    this.mappingAnnotationData();
    onAnnotationsStateChanged.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (event) => this.mappingAnnotationData(),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.annotations?.currentValue) {
      this.mappingAnnotationData();
    }
    if (changes.progressBarClickedTime) {
      this.applyProgressBarClickedTime(this.progressBarClickedTime);
    }
  }

  /**
   * When user clicks the progress bar at a given time:
   * - If time is null (parent reset): do nothing, keep current active state (avoids flash).
   * - If an annotation is already active: deactivate it, then activate the annotation at this
   *   time if one exists.
   * - If no annotation is active: activate the annotation at this time if any, else clear.
   */
  private applyProgressBarClickedTime(time: number | null): void {
    if (time == null || typeof time !== 'number' || Number.isNaN(time)) {
      return;
    }

    const list = this.annotations || [];
    const inRange = (a: any) => {
      const start = a?.range?.start;
      const end = a?.range?.end;
      const startNum = typeof start === 'number' && !Number.isNaN(start) ? start : null;
      const endNum = typeof end === 'number' && !Number.isNaN(end) ? end : startNum;
      if (startNum == null) return false;
      const rangeEnd = endNum ?? startNum;
      return time >= startNum && time <= rangeEnd;
    };

    const candidates = list.filter((a) => {
      const status = a?.comments?.[0]?.processingStatus;
      if (status === 'CANCELED' || status === 'TYPING') return false;
      return inRange(a);
    });

    const hadActive = !!this.activeAnnotation?.id;
    const activeStillValid =
      hadActive && candidates.some((a) => a?.id === this.activeAnnotation?.id) && inRange(this.activeAnnotation);

    if (activeStillValid) {
      return;
    }

    let annotationAtTime: any | null = null;
    if (candidates.length === 1) {
      annotationAtTime = candidates[0];
    } else if (candidates.length > 1) {
      annotationAtTime = null;
    }

    if (!annotationAtTime) {
      if (hadActive) {
        this.annotationActiveToggled = false;
        this.activeAnnotation = void 0;
        onAnnotationClickClosedV2.emit({
          itemId: this.item?.id,
          instanceId: this.instanceId,
        });
      }
      return;
    }

    this.activeAnnotation = annotationAtTime;
    this.annotationActiveToggled = true;
    this.scheduleModalPositionUpdate();
    onOpenAnnotation.emit({
      annotation: annotationAtTime,
      itemId: this.item?.id,
      instanceId: this.instanceId,
    });
    onAnnotationClickOpenedV2.emit({
      annotation: annotationAtTime,
      itemId: this.item?.id,
      instanceId: this.instanceId,
    });
  }

  /**
   * Schedules a single modal position update after the next paint.
   * Call when activeAnnotation is set so the comment preview is positioned correctly.
   * Avoids running heavy DOM reads (jQuery, getBoundingClientRect) on every change detection.
   */
  scheduleModalPositionUpdate(): void {
    if (this.modalPositionRafId != null) {
      cancelAnimationFrame(this.modalPositionRafId);
    }
    this.modalPositionRafId = requestAnimationFrame(() => {
      this.modalPositionRafId = null;
      if (this.annotationCommentModal?.nativeElement && this.activeAnnotation?.id) {
        this.calculateModalPosition();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.modalPositionRafId != null) {
      cancelAnimationFrame(this.modalPositionRafId);
      this.modalPositionRafId = null;
    }
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  onAnnotationHoverOpened(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.onTimeBarMouseEnter(args.annotation);
  }

  onAnnotationHoverClosed(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.onTimeBarMouseLeave(args.annotation);
  }

  onAnnotationClickOpened(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.activeAnnotation = args.annotation;
    this.annotationActiveToggled = true;
    this.scheduleModalPositionUpdate();
  }

  onAnnotationClickClosed(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.annotationActiveToggled = false;
    this.activeAnnotation = void 0;
  }

  onAddingAnnotationHandler(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.annotationActiveToggled = false;
    this.activeAnnotation = void 0;
    // this.isAnnotationActive = true;
  }

  onEditingAnnotationHandeler(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    this.annotationActiveToggled = false;
    this.activeAnnotation = void 0;
    // this.isAnnotationActive = true;
  }

  onCancelAddingAnnotationHandler(args: any) {
    if (args.instanceId != this.instanceId || args.itemId != this.item?.id) {
      return;
    }
    // this.isAnnotationActive = false;
  }

  onVideoPausedHandler(args: any) {
    this.isVideoPaused = true;
  }

  onVideoPlayHandler(args) {
    this.isVideoPaused = false;
  }

  mappingAnnotationData() {
    (this.annotations || []).forEach((annotation) => {
      let shapes: any = null;
      if (typeof annotation.shape === 'string') {
        try {
          shapes = JSON.parse(annotation.shape);
        } catch (e) {
          shapes = null;
        }
      } else {
        shapes = annotation.shape;
      }
      const same = parseInt(annotation.range.start) === parseInt(annotation.range.end);
      annotation.isCommentInTimeRange = !same;
      annotation.color = '#A9A9A9';
      annotation.colorOpacity = this.generalUtilsService.hexToRgbA(annotation.color, 0.4);
    });
    const isActiveAnnotationExist = this.annotations.find((a) => a.id === this.activeAnnotation?.id);
    if (!isActiveAnnotationExist) {
      this.annotationActiveToggled = false;
      this.activeAnnotation = void 0;
    }
    // this.sortAnnotations(); // Not being used anymore and causing issues as it's modifying the variable inside plugin
    this.mapAnnotation2DMatrix();
  }

  sortAnnotations() {
    if (!this.annotations || !Array.isArray(this.annotations)) {
      return;
    }
    this.annotations.sort((annotationA: any, annotationB: any) => {
      const annotationALastReply = Math.max(
        ...[...annotationA.comments.map((comment: any) => comment.meta.updatetime)]
      );
      const annotationBLastReply = Math.max(
        ...[...annotationB.comments.map((comment: any) => comment.meta.updatetime)]
      );
      return annotationBLastReply - annotationALastReply;
    });
  }

  mapAnnotation2DMatrix() {
    if (!this.annotations || !Array.isArray(this.annotations)) {
      this.annotationIn2DMatrixDataModel = [];
      this._cachedDuration = null;
      return;
    }
    this._cachedDuration = null;
    const annotationsIn2DMatrix = [];
    const filteredAnnotations = this.annotations.filter((a) => {
      const start = a?.range?.start;
      const hasValidStart = typeof start === 'number' && !Number.isNaN(start);
      const status = a?.comments?.[0]?.processingStatus;
      const isCanceledOrTyping = status === 'CANCELED' || status === 'TYPING';
      return hasValidStart && !isCanceledOrTyping;
    });
    for (let i = 0; i < filteredAnnotations.length; i++) {
      let j: number;
      for (j = 0; j < annotationsIn2DMatrix.length; j++) {
        let rows = annotationsIn2DMatrix[j],
          k: number;
        for (k = 0; k < rows.length; k++) {
          if (filteredAnnotations[i].range.start === rows[k].range.start) {
            break;
          }
        }
        if (k === rows.length) {
          rows.push(filteredAnnotations[i]);
          break;
        }
      }
      if (!annotationsIn2DMatrix.length) {
        annotationsIn2DMatrix.push([filteredAnnotations[i]]);
      } else if (j === annotationsIn2DMatrix.length) {
        annotationsIn2DMatrix.push([filteredAnnotations[i]]);
      }
    }

    this.annotationIn2DMatrixDataModel = annotationsIn2DMatrix.filter((a) => a.length);
    this.buildTimelineItems(filteredAnnotations);
    onFirstRowMarkersReady.emit({
      firstRowAnnotation: annotationsIn2DMatrix[0],
      itemId: this.item?.id,
      instanceId: this.instanceId,
    });
  }

  private buildTimelineItems(filteredAnnotations: any[]): void {
    const byStart = new Map<number, any[]>();
    for (const a of filteredAnnotations) {
      const start = Number(a?.range?.start);
      if (Number.isNaN(start)) continue;
      const key = start;
      if (!byStart.has(key)) byStart.set(key, []);
      byStart.get(key)!.push(a);
    }
    const items: typeof this.timelineItems = [];
    byStart.forEach((annotations, startTime) => {
      if (annotations.length > 1) {
        items.push({ type: 'group', startTime, annotations });
      } else {
        items.push({ type: 'single', startTime, annotation: annotations[0] });
      }
    });
    items.sort((a, b) => a.startTime - b.startTime);
    this.timelineItems = items;
  }

  getSelectedInGroup(item: { type: 'group'; startTime: number; annotations: any[] }): any {
    if (item.type !== 'group' || !item.annotations?.length) return null;
    const active = this.activeAnnotation;
    if (active?.id && item.annotations.some((a) => a?.id === active?.id)) return active;
    return item.annotations[0];
  }

  isDropUpOpen(startTime: number): boolean {
    return this.dropUpOpenStartTime === startTime;
  }

  toggleDropUp(startTime: number): void {
    const willOpen = this.dropUpOpenStartTime !== startTime;
    this.dropUpOpenStartTime = this.dropUpOpenStartTime === startTime ? null : startTime;
    if (willOpen && this.dropUpOpenStartTime != null) {
      this.dropUpJustOpened = true;
      setTimeout(() => (this.dropUpJustOpened = false), 0);
    }
  }

  /**
   * Group bar mouse enter: only update hover state when drop-up is closed and group already has a selection.
   * When drop-up is open, do not change activeAnnotation so user's click selection is not overwritten.
   * When group has no active/selected annotation, do not set activeAnnotation on hover (avoids pre-selecting first).
   */
  onGroupBarMouseEnter(item: { type: 'group'; startTime: number; annotations: any[] }): void {
    if (this.isDropUpOpen(item.startTime)) return;
    if (!this.isGroupActive(item)) return;
    this.onTimeBarMouseEnter(this.getSelectedInGroup(item), true);
  }

  /**
   * Group bar mouse leave: only clear hover state when drop-up is closed.
   * When drop-up is open, do not clear so selection from list is preserved.
   */
  onGroupBarMouseLeave(item: { type: 'group'; startTime: number; annotations: any[] }): void {
    if (this.isDropUpOpen(item.startTime)) return;
    this.onTimeBarMouseLeave(this.getSelectedInGroup(item), true);
  }

  closeDropUp(): void {
    this.dropUpOpenStartTime = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.dropUpOpenStartTime == null || this.dropUpJustOpened) return;
    const el = this.elementRef.nativeElement;
    if (el.contains(event.target as Node)) return;
    this.closeDropUp();
  }

  selectFromGroup(annotation: any): void {
    this.activeAnnotation = annotation;
    this.annotationActiveToggled = true;
    this.scheduleModalPositionUpdate();
    onOpenAnnotation.emit({
      annotation,
      itemId: this.item?.id,
      instanceId: this.instanceId,
    });
    onAnnotationClickOpenedV2.emit({
      annotation,
      itemId: this.item?.id,
      instanceId: this.instanceId,
    });
    this.dropUpOpenStartTime = null;
    this.cdr.detectChanges();
  }

  /** trackBy for *ngFor over timelineItems to reduce re-renders. */
  trackByTimelineItem(_index: number, item: (typeof this.timelineItems)[0]): number | string {
    if (item.type === 'single') return item.annotation?.id ?? item.startTime;
    return item.startTime;
  }

  /** Compare annotation id for drop-up active state (avoids string vs number mismatch). */
  isActiveInDropUp(ann: any): boolean {
    if (!ann || !this.activeAnnotation) return false;
    return String(ann.id) === String(this.activeAnnotation.id);
  }

  /** Get left % for a start time (for group or single). */
  getLeftPercent(startTime: number): number {
    const duration = this.getDuration();
    if (!duration || Number.isNaN(duration)) return 0;
    return (startTime / duration) * 100;
  }

  /** Get width % for a group: use selected annotation's width, or max of group. */
  getGroupWidth(item: { type: 'group'; startTime: number; annotations: any[] }): number {
    const sel = this.getSelectedInGroup(item);
    if (sel) return this.getAnnotationWidth(sel);
    return Math.max(...item.annotations.map((a) => this.getAnnotationWidth(a)), 1);
  }

  /** Whether the group should use single-point style (selected annotation has very short range). */
  getGroupIsSingle(item: { type: 'group'; startTime: number; annotations: any[] }): boolean {
    const sel = this.getSelectedInGroup(item);
    if (!sel?.range) return false;
    const end = sel.range?.end ?? sel.range?.start;
    return end - sel.range?.start <= 0.5;
  }

  /** Whether this group has the active annotation. */
  isGroupActive(item: { type: 'group'; startTime: number; annotations: any[] }): boolean {
    if (!this.activeAnnotation?.id) return false;
    return item.annotations.some((a) => a?.id === this.activeAnnotation?.id);
  }

  /** Whether this group is toggled (active and toggled). */
  isGroupToggled(item: { type: 'group'; startTime: number; annotations: any[] }): boolean {
    return this.annotationActiveToggled && this.isGroupActive(item);
  }

  /** First comment body snippet for drop-up list label (plain text, no HTML). */
  getCommentPreview(annotation: any): string {
    const body = annotation?.comments?.[0]?.body;
    if (body == null || typeof body !== 'string') return '';
    const plain = this.stripHtml(body).trim();
    return plain.length > 25 ? plain.slice(0, 25) + '…' : plain;
  }

  /** Remove HTML tags so text is safe to show as plain label. */
  private stripHtml(html: string): string {
    const div = typeof document !== 'undefined' ? document.createElement('div') : null;
    if (div) {
      div.innerHTML = html;
      return div.textContent ?? div.innerText ?? '';
    }
    return html.replace(/<[^>]*>/g, '');
  }

  showMoreAnnotations() {
    this.activeAnnotation = void 0;
    this.isShowMoreAnnotations = !this.isShowMoreAnnotations;
  }

  onTimeBarMouseEnter(annotation: any, fireEventToPlugin?: boolean) {
    if (this.annotationActiveToggled) return;
    this.activeAnnotation = annotation;
    this.scheduleModalPositionUpdate();
    if (fireEventToPlugin) {
      onAnnotationMarkerSelectedActiveHover.emit({
        annotation: annotation,
        instanceId: this.instanceId,
        itemId: this.item?.id,
      });
    }
  }

  onTimeBarMouseLeave(annotation: any, fireEventToPlugin?: boolean) {
    if (this.annotationActiveToggled) return;
    this.activeAnnotation = void 0;
    if (fireEventToPlugin) {
      onAnnotationMarkerSelectedInActiveHover.emit({
        annotation: annotation,
        instanceId: this.instanceId,
        itemId: this.item?.id,
      });
    }
  }

  getDuration(): number {
    if (this._cachedDuration != null && !Number.isNaN(this._cachedDuration)) {
      return this._cachedDuration;
    }
    let duration: number | undefined;
    if (this.isAudio && this.annotationPlugin && this.player) {
      duration = this.player.getDuration();
    } else if (this.isVideo && this.annotationPlugin && this.player && this.isPlayerReady) {
      duration = this.player.duration();
    }
    const value = typeof duration === 'number' && !Number.isNaN(duration) ? duration : 0;
    this._cachedDuration = value;
    return value;
  }

  getAnnotationWidth(annotation: any) {
    let width = 0;
    const duration = this.getDuration();
    if (((this.isVideo && this.player && this.isPlayerReady) || this.isAudio) && this.annotationPlugin && annotation) {
      if (Number.isNaN(duration)) {
        return 0;
      }
      const rawStart = annotation?.range?.start;
      const rawEnd = annotation?.range?.end;
      const start = typeof rawStart === 'number' && !Number.isNaN(rawStart) ? rawStart : 0;
      const end = typeof rawEnd === 'number' && !Number.isNaN(rawEnd) ? rawEnd : null;
      const safeEnd = end === null ? start : end;
      const normalizedEnd = safeEnd < start ? start : safeEnd;
      width = (normalizedEnd / duration) * 100 - (start / duration) * 100;
    }
    return width === 0 ? 1 : width;
  }

  getAnnotationLeft(annotation: any) {
    let left = 0;
    const duration = this.getDuration();
    if (((this.isVideo && this.player && this.isPlayerReady) || this.isAudio) && this.annotationPlugin && annotation) {
      left = (annotation.range.start / duration) * 100;
    }
    return left;
  }

  getAnnotationTop(row: any, index: any) {
    return row * 24 - index * 24;
  }

  getAnnotationZIndex(annotation: any) {
    return (annotation?.range?.start ?? 0) * 10;
  }

  annotationBarClick(annotation: any, fireEventToPlugin?: boolean) {
    if (this.isAnnotationActive) {
      this.notificationService
        .open({
          description: 'You have an unsaved annotation/comment. Continue without saving?',
          confirmBtn: 'Continue',
          cancelBtn: 'Cancel',
          windowClass: 'discard-annotation-modal',
          icon: 'warning',
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((confirm) => {
          if (confirm) {
            if (this.annotationActiveToggled) {
              this.annotationActiveToggled = false;
              this.activeAnnotation = void 0;
              if (fireEventToPlugin) {
                onAnnotationMarkerSelectedInActiveClick.emit({
                  itemId: this.item?.id,
                  instanceId: this.instanceId,
                });
              }
            } else {
              this.annotationActiveToggled = true;
              this.activeAnnotation = annotation;
              this.scheduleModalPositionUpdate();
              onAnnotationFocused.emit({ act: 'onAnnotationFocused', instanceId: this.instanceId });
              onOpenAnnotation.emit({
                act: 'openAnnotation',
                annotation: annotation,
                instanceId: this.instanceId,
                itemId: this.item?.id,
              });
              // if (fireEventToPlugin) {
              // onAnnotationMarkerSelectedActiveClick.emit({
              // 	annotation: annotation,
              // 	instanceId: this.instanceId,
              // 	itemId: this.item?.id
              // });
              // }
            }
            onCancelAddingAnnotation.emit({
              act: 'cancelAddingAnnotation',
              instanceId: this.instanceId,
              itemId: this.item?.id,
              type: 'barlist',
            });
          }
        });
    } else {
      this.annotationActiveToggled = !this.annotationActiveToggled;
      //this.activeAnnotation = this.annotationActiveToggled ? annotation : void 0;
      // onAnnotationFocused.emit({
      // 	act: 'onAnnotationFocused',
      // 	instanceId: this.instanceId
      // });
      // console.log("annotationActiveToggled", annotation);
      if (this.annotationActiveToggled) {
        this.scheduleModalPositionUpdate();
        // onOpenAnnotation.emit({
        // 	act: 'openAnnotation',
        // 	annotation: annotation,
        // 	instanceId: this.instanceId,
        // 	itemId: this.item?.id
        // });
      }
      onOpenAnnotation.emit({
        annotation: annotation,
        itemId: this.item?.id,
        instanceId: this.instanceId,
      });
      if (!this.annotationActiveToggled) {
        onAnnotationClickClosedV2.emit({
          annotation: annotation,
          itemId: this.item?.id,
          instanceId: this.instanceId,
        });
      }
      // if (fireEventToPlugin) {
      // onAnnotationMarkerSelectedActiveClick.emit({
      // 	annotation: annotation,
      // 	instanceId: this.instanceId,
      // 	itemId: this.item?.id
      // });
      // }
    }
  }

  calculateModalPosition() {
    const $element = $('.annotation-time-range-bar.annotation-active');
    const $parentContainer = $('.videojs-annotation-control-bar-list');
    if ($element.length) {
      const parentBoundingRect = $parentContainer[0].getBoundingClientRect();
      let modalWidth: any, modalLeft: any, modalTop: any;
      if (parentBoundingRect.width >= 420) {
        modalWidth = 416;
      } else {
        modalWidth = parentBoundingRect.width - 4;
      }
      const boundModal = this.annotationCommentModal.nativeElement.getBoundingClientRect();
      const position = $element.position();
      if (
        1 -
          position.left /
            ($parentContainer[0].getBoundingClientRect().left +
              $parentContainer[0].getBoundingClientRect().width / 2) >=
        0.5
      ) {
        modalLeft = position.left + 4;
        modalTop = position.top - boundModal.height;
        this.concatPosition = {
          bottom: boundModal.top + boundModal.height - ($element[0].getBoundingClientRect().top + 2),
          height: $element[0].getBoundingClientRect().top - (boundModal.top + boundModal.height) + 3,
          left: 5,
          width: modalWidth,
        };
      } else {
        modalLeft = position.left - boundModal.width;
        modalTop = position.top - boundModal.height;
        this.concatPosition = {
          bottom: boundModal.top + boundModal.height - ($element[0].getBoundingClientRect().top + 2),
          height: $element[0].getBoundingClientRect().top - (boundModal.top + boundModal.height) + 3,
          left: boundModal.width - 8,
          width: modalWidth,
        };
      }
      if (modalLeft < 0) {
        modalLeft = 0;
      } else if (modalLeft + modalWidth > parentBoundingRect.width) {
        modalLeft = parentBoundingRect.width - modalWidth;
      }
      this.modalPosition = {
        top: modalTop - 64,
        left: modalLeft,
        width: modalWidth,
      };
    }
  }
}
